import React from "react";

export const Logo = ({ className = "", testId = "logo" }) => (
  <span
    data-testid={testId}
    className={`font-display text-[1.35rem] sm:text-2xl tracking-tight inline-flex items-center gap-1 text-[#2C1E16] ${className}`}
  >
    <span>M</span>
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="w-4 h-4 sm:w-[18px] sm:h-[18px] -mt-0.5"
      fill="#D4A373"
    >
      <path d="M12 21s-7.5-4.7-9.6-9.2C.7 7.9 3.2 4 7.1 4c2 0 3.6 1.1 4.9 2.8C13.3 5.1 14.9 4 16.9 4c3.9 0 6.4 3.9 4.7 7.8C19.5 16.3 12 21 12 21z" />
    </svg>
    <span>C</span>
  </span>
);
